import React, { Component, useState, useEffect } from 'react'
import Table from 'view/component/Table';
import * as XLSX from "xlsx";
import moment from 'moment';
import { date } from 'yup';
import apiService from 'apiService';
import { toast } from 'view/component/Alert';
import Export from 'view/dinas/laporan/components/Export';

const groupBy = (array, key) => {
    // Return the end result
    return array.reduce((result, currentValue) => {
        // If an array already present for key, push it to the array. Else create an array and push the object
        (result[currentValue[key]] = result[currentValue[key]] || []).push(
            currentValue
        );
        // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
        return result;
    }, {}); // empty object is the initial value for result object
};

const ImportData = (props) => {
    let header = JSON.parse(localStorage.getItem("puskesmasProfile"));
    const [datas, setdatas] = useState([])
    const [param, setParam] = useState({
        city: '',
        vaccine_receiver_category_id: '',
        first_date: null,
        second_date: null,
        flags: '',
        reasons: 0,
        vaccine: true,
        detail: []
    })
    const [flags, setFlags] = useState([])
    const [reasons, setReasons] = useState([])
    const [category, setCategory] = useState([]);
    const [provinces, setProvinces] = useState([])
    const [cities, setCities] = useState([])
    const [demographicData, setDemographicData] = useState({
        province: 34,
        cities: 3403,
        districts: '',
        villages: "",
    });
    const [status, setStatus] = useState(false)
    const fetchProvince = async () => {
        const res = await apiService.get("demograph/provinces");
        if (res) {
            if (res.code === 200) {
                setProvinces(res.data)
            }
        }
    };
    const fetchCities = async () => {
        const res = await apiService.get("demograph/provinces/find/" + demographicData.province);
        if (res) {
            if (res.status === "success.") {
                setCities(res.data?.cities)
            }
        }
    };
    const onChangeDemograph = (event) => {
        const value = event.target.value;
        const object = event.target.name;

        setDemographicData({
            ...demographicData,
            [object]: value,
        });
    };

    useEffect(() => {
        fetchProvince();
        fetchCities();
    }, [provinces.length])

    useEffect(() => {
        fetchCities();
    }, [demographicData.province])


    const readFile = (e) => {
        e.stopPropagation();
        e.preventDefault();
        var f = e.target.files[0];
        var name = f.name;
        const reader = new FileReader();
        reader.onload = (evt) => {
            // evt = on_file_select event
            /* Parse data */
            const bstr = evt.target.result;
            const wb = XLSX.read(bstr, { type: "binary" });
            /* Get first worksheet */
            const wsname = wb.SheetNames[0];
            const ws = wb.Sheets[wsname];
            /* Convert array of arrays */
            const data = XLSX.utils.sheet_to_csv(ws, { header: 2 });
            if (convertToJson(data).length > 0) {
                // let d = groupBy(convertToJson(data), 'nik');
                // let group = Object.keys(d);
                setdatas(convertToJson(data))
            }

        };
        reader.readAsBinaryString(f);
    }
    const convertToJson = (csv) => {
        var lines = csv.split("\n");
        var result = [];
        for (var i = 1; i < lines.length; i++) {
            var obj = {};
            var currentline = lines[i].split(";");
            let dat = currentline[0].split(',');
            try {
                if (dat.length > 0 && dat[0] !== '') {
                    obj['kd_puskesmas'] = dat[0];
                    obj['nik'] = dat[5].match(/\d/g).join('');
                    obj['name'] = dat[6];
                    obj['sex'] = dat[7];
                    obj['faskes'] = dat[4];
                    // obj['district'] = dat[5];
                    // obj['village'] = dat[6];
                    // obj['address'] = dat[7];
                    // obj['rw'] = dat[8];
                    // obj['rt'] = dat[9];
                    // obj['age'] = dat[10];
                    // obj['job_agency'] = dat[11];
                    // obj['phone_number'] = "62";
                    obj['kelompok_usia'] = dat[8];
                    obj['kategori'] = dat[9];
                    obj['sub_ketegori'] = dat[10];
                    obj['dosis'] = dat[11];
                    obj['tiket'] = dat[12];
                    obj['jenis'] = dat[13];
                    result.push(obj);
                }
            } catch (error) {
            }
        }
        //return result; //JavaScript object
        return result; //JSON
    }

    const getCategory = async (age) => {
        let res = await apiService.get("/vaccine/categories/read");

        if (res && res.code === 200) {
            setCategory(res.data);
        }
    };
    const getFlags = async (age) => {
        let res = await apiService.get("/vaccine/flags");

        if (res && res.code === 200) {
            setFlags(res.data);
        }
    };
    const getReason = async (age) => {
        let res = await apiService.get("/vaccine/reasons");

        if (res && res.code === 200) {
            setReasons(res.data);
        }
    };
    useEffect(() => {
        getCategory()
        getFlags()
        getReason()
        // getKec()
    }, [1])

    const postImport = async () => {
        toast({ status: "info", text: 'Data Diproses' })
        setStatus(true)
        let par = { ...param, detail: datas, city: demographicData.cities }
        // console.log(par)
        let res = await apiService.post("/vaccine/registration/store_check", par);
        if (res && res.code === 200) {
            toast({ status: "success", text: 'Data Berhasil di import' })
            setdatas(res.data.filter(e => e.upload_status === "NIK tidak ditemukan"))
            setStatus(false)
        } else {
            toast({ status: "error", text: 'Data Gagal diimport' })
            setStatus(false)
        }
    }

    const getNik = async () => {
        toast({ status: "info", text: 'Data Diproses' })
        setStatus(true)
        let par = {
            nik: []
        }
        datas.map((a, k) => {
            par.nik.push(a.nik)
        })
        console.log(par)
        let res = await apiService.post("/iks/personals/import", par);
        if (res && res.code === 200) {
            let x = [];
            res.data.map((a, b) => {
                let y = datas.find(e => e.nik === a.nik);
                y.upload_status = a.status
                x.push(y)
            })
            toast({ status: "success", text: 'Data NIK Berhasil di import' })
            setdatas(x)
            setStatus(false)
        } else {
            toast({ status: "error", text: 'Data Tidak Ditemukan' })
            setStatus(false)
        }
    }
    return (
        <div>
            <div className='main-content mt-4'>
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='card col-md-12'>
                            <div className='card-header text-center'>
                                <div className='h3 mb-2'>
                                    IMPORT DATA PESERTA VAKSINASI {header?.report_header_1}
                                </div>
                                <div className='h3 mb-2'>
                                    FASILITAS KESEHATAN {header?.name?.toUpperCase()}
                                </div>
                                <div className="mt-5 row c0l-md-12">
                                    <div className="form-group col-md-6 row">
                                        <label
                                            htmlFor="example-text-input"
                                            className="col-md-5 col-form-label col-form-label-sm"
                                        >
                                            Provinsi
                                         </label>
                                        <div className="col-md-7">
                                            <div className="row">
                                                <select
                                                    className={
                                                        "form-control form-control-sm"
                                                    }
                                                    name='province'
                                                    id='province'
                                                    value={demographicData.province}
                                                    onChange={(e) => onChangeDemograph(e)}
                                                >
                                                    <option>-</option>
                                                    {
                                                        provinces.map((data, k) => (
                                                            <option key={k} value={data.id}>{data.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group col-md-6 row">
                                        <label
                                            htmlFor="example-text-input"
                                            className="col-md-5 col-form-label col-form-label-sm"
                                        >
                                            Kabupaten
                                         </label>
                                        <div className="col-md-7">
                                            <div className="row">
                                                <select
                                                    className={
                                                        "form-control form-control-sm"
                                                    }
                                                    name='cities'
                                                    id='cities'
                                                    value={demographicData.cities}
                                                    onChange={(e) => onChangeDemograph(e)}
                                                >
                                                    <option>-</option>
                                                    {
                                                        cities.map((data, k) => (
                                                            <option key={k} value={data.id}>{data.name}</option>
                                                        ))
                                                    }
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="row">
                                        <div className="form-group col-md-6 row">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-md-5 col-form-label col-form-label-sm"
                                            >
                                                Kategori Peserta
                                         </label>
                                            <div className="col-md-7">
                                                <div className="row">
                                                    <select
                                                        className="form-control form-control-sm "
                                                        id="example-text-input"
                                                        name="vaccine_receiver_category_id"
                                                        onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                                                        value={param.vaccine_receiver_category_id}
                                                    >
                                                        <option>pilih data ...</option>
                                                        {category?.map((a, b) => {
                                                            return (
                                                                <option value={a.id} key={b}>
                                                                    {a.name}
                                                                </option>
                                                            )
                                                        }

                                                        )}

                                                    </select>
                                                    {/* {errors.vaccine_receiver_category_id && touched.vaccine_receiver_category_id ? (
                                                    <div style={{ color: "red" }}>&nbsp; {errors.vaccine_receiver_category_id}</div>
                                                ) : null} */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6 row">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-md-5 col-form-label col-form-label-sm"
                                            >
                                                Status Vaksinasi
                                             </label>
                                            <div className="col-md-7">
                                                <div className="row">
                                                    <select
                                                        className="form-control form-control-sm "
                                                        id="example-text-input"
                                                        name="flags"
                                                        onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                                                        value={param.flags}
                                                    >
                                                        <option>pilih data ...</option>
                                                        {flags?.map((a, b) => {
                                                            return (
                                                                <option value={a.id} key={b}>
                                                                    {a.name}
                                                                </option>
                                                            )
                                                        }

                                                        )}

                                                    </select>
                                                    {/* {errors.flags && touched.flags ? (
                                                    <div style={{ color: "red" }}>&nbsp; {errors.flags}</div>
                                                ) : null} */}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {param.flags > 2 ?

                                        <div className="form-group col-md-6 row">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-md-5 col-form-label col-form-label-sm"
                                            >
                                                Alasan
                                            </label>
                                            <div className="col-md-7">
                                                <div className="row">
                                                    <select
                                                        className="form-control form-control-sm col-md-12"
                                                        id="example-text-input"
                                                        name="reason"
                                                        onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                                                        value={param.reason}
                                                    >
                                                        <option value={0}>pilih data ...</option>
                                                        {reasons?.map((a, b) => (
                                                            <option value={a.id} key={b}>
                                                                {a.name}
                                                            </option>
                                                        ))}
                                                    </select>
                                                    {/* {errors.reason && touched.reason ? (
                                                        <div style={{ color: "red" }}>&nbsp; {errors.reason}</div>
                                                    ) : null} */}
                                                </div>
                                            </div>
                                        </div>
                                        : ''}
                                    <div className="row">
                                        <div className="form-group col-md-6 row">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-md-5 col-form-label col-form-label-sm"
                                            >
                                                Tanggal Vaksin 1
                                         </label>
                                            <div className="col-md-7">
                                                <div className="row">
                                                    <input
                                                        className={
                                                            "form-control form-control-sm"
                                                        }
                                                        type='datetime-local'
                                                        name='first_date'
                                                        id='first_date'
                                                        value={param.first_date}
                                                        onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                                                    />
                                                    {/* {errors.first_date && touched.first_date ? (
                                                    <div className='invalid-feedback'>{errors.first_date}</div>
                                                ) : null} */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group col-md-6 row">
                                            <label
                                                htmlFor="example-text-input"
                                                className="col-md-5 col-form-label col-form-label-sm"
                                            >
                                                Tanggal Vaksin 2
                                         </label>
                                            <div className="col-md-7">
                                                <div className="row">
                                                    <input
                                                        className={
                                                            "form-control form-control-sm"
                                                        }
                                                        type='datetime-local'
                                                        name='second_date'
                                                        id='second_date'
                                                        value={param.second_date}
                                                        onChange={(e) => setParam({ ...param, [e.target.name]: e.target.value })}
                                                    />

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='row pt-2'>
                                    <div className="form-group col-md-6 m-0">
                                        <div className="input-group">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text text-default">Pilih File Upload</span>
                                            </div>
                                            <input
                                                className="form-control"
                                                type="file"
                                                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                                                onChange={(e) => {
                                                    readFile(e);
                                                    e.target.value = null;
                                                }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div >
                                        <button className="btn btn-primary" disabled={status} onClick={(e) => postImport()}> {status ? 'Sedang Memproses Data' : 'Import Data'} </button>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                <Table
                                    headers={[
                                        "No",
                                        "Status",
                                        "Faskes",
                                        "NIK",
                                        "Nama",
                                        "Jenis Kelamin",
                                        'kelompok_usia',
                                        'kategori',
                                        'sub_ketegori',
                                        'dosis',
                                        'tiket',
                                        'jenis',

                                    ]}
                                    data={datas}
                                    columnMapper={(data, key) => [
                                        data.upload_status ? data.upload_status : "Berhasil Dibaca",
                                        data.kd_puskesmas,
                                        data.nik,
                                        data.name,
                                        data.sex,
                                        data.kelompok_usia,
                                        data.kategori,
                                        data.sub_ketegori,
                                        data.dosis,
                                        data.tiket,
                                        data.jenis,
                                    ]}
                                    pagination={true}
                                />

                            </div>
                            <div className="card-footer">
                                <div className="row">
                                    <Export
                                        csvData={datas}
                                        fileName={"Gagal Upload"}
                                        columnMapper={(data) => {
                                            return {
                                                kd_puskesmas: data.kd_puskesmas ,
                                                Status: data.upload_status ? data.upload_status : "Berhasil Dibaca",
                                                Provinsi: '',
                                                Kabupaten: '',
                                                Faskes: data.faskes,
                                                nik: data.nik,
                                                nama: data.name,
                                                jk: data.sex,
                                                kel_usia: data.kelompok_usia,
                                                kategori: data.kategori,
                                                sub: data.sub_ketegori,
                                                dosis: data.dosis,
                                                no_tiket: data.tiket,
                                                jenis: data.jenis,

                                            };
                                        }}
                                    />
                                    {datas[0]?.upload_status === 'NIK tidak ditemukan' ? (
                                        <button className="btn btn-info" onClick={() => getNik()}>Get NIK</button>
                                    ) : ''}
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default ImportData
